import { render, staticRenderFns } from "./sale-stock-item-price-list.vue?vue&type=template&id=6b966dd6&"
import script from "./sale-stock-item-price-list.vue?vue&type=script&lang=js&"
export * from "./sale-stock-item-price-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports